import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const USERS = [
	{ username: "Nicholas", password: "Ottoisthebest2025!!" },
	{ username: "Erin", password: "Ottoisthebest2025!" },
];

const Login = ({ setLoggedInUser }) => {
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const navigate = useNavigate();

	const handleSubmit = (e) => {
		e.preventDefault();
		const user = USERS.find((u) => u.password === password);
		if (user) {
			localStorage.setItem("loggedInUser", user.username);
			setLoggedInUser(user.username);
			setError("");
			navigate("/dashboard");
		} else {
			setError("Access Denied");
		}
	};

	return (
		<div className="login-page">
			<form onSubmit={handleSubmit} className="login-form">
				<input type="text" placeholder="username" value="lavella" style={{ display: "none" }} />
				<input type="password" placeholder="access" value={password} onChange={(e) => setPassword(e.target.value)} />
				<button type="submit">Login</button>
				{error && <p className="error">{error}</p>}
			</form>
		</div>
	);
};

export default Login;
